import React, { useEffect, useState,useContext } from "react";
import { Navbar, Container, Nav, Button, Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useCart, usePromoCodeInput, useTimer,EventContext } from './CartContext';

export default function PageHeader() {
  const { timeLeft, setTimeLeft, isTimeActive, stopTimer, resetTimer } = useTimer(); // Timer context
  const [showModal, setShowModal] = useState(false); // Modal state
  const navigate = useNavigate(); // Navigation hook
  const { SetGlobalCartId } = useCart(); // Access cart context
  const { promoCodeInput, updatePromoCode, setUrlPromoCleared  } = usePromoCodeInput(); // Promo code context
  const { settings, globalEventId } = useContext(EventContext);

  useEffect(() => {
    document.title = settings?.EVENT_NAME;
  }, [settings])

  // Countdown timer logic
  useEffect(() => {
    let timer;
    if (isTimeActive) {
      timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            handleTimeout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isTimeActive, setTimeLeft]);

  const handleTimeout = () => {
    // Clear cart and promo code
    SetGlobalCartId({
      cartID: '',
      cartContents: new Map(),
    });
    updatePromoCode(globalEventId,'');
    localStorage.removeItem('cartID'); // Remove cart ID from localStorage

    // Show timeout modal
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    navigate('/'); // Redirect to the home page
  };

  const handleRemovePromoCode = () => {
    updatePromoCode(globalEventId,'');
    setUrlPromoCleared(true); 
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  return (
    <>
      <Navbar expand={false} className="bg-body-secondary">
        <Container>
          <Navbar.Brand>
            <picture>
              <source srcSet={`${process.env.REACT_APP_CDN_URL}/${settings?.EVENT_URL}/${settings?.LOGO}`} media="(min-width: 992px)" />
              <img src={`${process.env.REACT_APP_CDN_URL}/${settings?.EVENT_URL}/${settings?.MOBILE_LOGO || settings?.LOGO}`} alt="Logo" style={{ height: "40px" }} />
            </picture>
          </Navbar.Brand>
          {/* Only display the timer if it's active */}
          {isTimeActive && (
            <div>Timer: {formatTime(timeLeft)}</div>
          )}
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto text-end mt-2">
              <Link to={'/'}>Home</Link>
            </Nav>
            <Nav className="me-auto text-end mt-2">
              <Link to={'/cart'}>Cart/Store</Link>
            </Nav>
            <Nav className="me-auto text-end mt-2">
              <Link to={'/my-account'}>My Account</Link>
            </Nav>
          </Navbar.Collapse>
          {promoCodeInput && (
            <p className="text-start text-success small p-0 m-0">
              Promo Code: {promoCodeInput} applied 
              <i onClick={handleRemovePromoCode} style={{ cursor: 'pointer', color: 'red', marginLeft: '8px' }} class="bi bi-x-circle"></i>
            </p>
          )}
        </Container>
      </Navbar>

      {/* Timeout Modal */}
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Session Expired</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your session has expired. Please restart your order process.</Modal.Body>
        <Modal.Footer>
          <Button className="btn-atc" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}